import { Paper, Button } from "@mui/material";
import {useOutletContext} from "react-router-dom"
import { DataGrid ,GridToolbarContainer,GridToolbarFilterButton, GridToolbarQuickFilter} from '@mui/x-data-grid';
import { useState } from "react";
import ReAuthDeleteDialog from "../../components/ReAuthDeleteDialog";
import { Action as Managed } from "../../features/db/action";
import Dialog from "../../components/NewActionDialog";

export default function ChemicalPage() {
	const { actionsContainer } = useOutletContext();
	const [rows, setRows] = actionsContainer;

	const [selectionModel, setSelectionModel] = useState([]);

	const columns = [
		{ field: 'name', headerName: 'Action', flex:1},
		{ field: 'chemical', headerName: 'Chemical Use', type: 'boolean', flex:0.5},
	];

	const submitCallback = (p)=>
	{
		setRows([...rows, p]);
	}

	const handleDelete = ()=>
	{
		if(selectionModel.length > 0)
		{
			Managed.deleteAndUpdate(selectionModel,rows,setRows);
		}
	}

	const handleToggleStatus = ()=>
	{
		if(selectionModel.length > 0)
		{
			let temp = rows.map(project => {
				const key = project.id;
				if(selectionModel.includes(key))
				{
					project.chemical = !project.chemical;
					Managed.submitUpdate(project);
				}
				return project;
			});
			setRows(temp);
		}
	}

	const CustomToolbar = ({ setFilterButtonEl }) => (
		<GridToolbarContainer>
			<GridToolbarQuickFilter/>
			<GridToolbarFilterButton ref={setFilterButtonEl} />
			<Dialog submitCallback={submitCallback}/>
			<Button onClick={handleToggleStatus}>Toggle Chemical</Button>
			<ReAuthDeleteDialog handleDelete = {handleDelete} selectionSize = {selectionModel.length}/>
		</GridToolbarContainer>
	);

	return (
		<Paper varient="outlined" sx={{m:2}} elevation={10}>
			<DataGrid
				autoHeight
				rows={rows}
				columns={columns}
				checkboxSelection
				components={{Toolbar: CustomToolbar }}
				disableColumnSelector
				disableDensitySelector
				onSelectionModelChange = {(newSelectionModel) => {
					setSelectionModel(newSelectionModel);
				}}
				selectionModel={selectionModel}
				getRowHeight={() => 'auto'}
			/>
		</Paper>
	);
}